<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ modalTitle }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="row">
      <div class="col-sm-2"></div>

      <div class="col-sm-8">

        <div class="form-group">
          <label>{{ lang?.date_of_execution }}</label>
          <input type="date" class="form-control" formControlName="exam_date"
            [ngClass]="formErrorClass(createForm.controls.exam_date, createFormSubmitted)">
          <span class="text-danger"
            *ngIf="(createForm.controls.exam_date?.touched || createFormSubmitted) && createForm.controls.exam_date?.errors?.required">
            This field is required.
          </span>
        </div>

        <div class="form-group">
          <label>{{ lang?.intervention_days_notify }}</label>
        </div>

        <div class="form-group">
          <div class="change-affect col-sm-9">
            <label class="checked checkbox-inline"><input name="change_deadline" value="skip" type="radio"> Skip  </label>&nbsp;&nbsp;
            <label class="checked checkbox-inline"><input name="change_deadline" value="change" type="radio"> Change  </label>&nbsp;&nbsp;
            <label class="checked checkbox-inline"><input name="change_deadline" value="do_no_affect" type="radio" checked=""> Do not affect  </label>&nbsp;&nbsp;
          </div>
       </div>
      </div>
      <div class="col-sm-2"></div>
    </div>


    <div class="form-group">
      <table datatable [dtOptions]="datatableOptions" class="table-striped table-sm row-border hover" id="table1">
        <thead>
          <tr>
            <th>No</th>
            <th>{{ lang?.employees }}</th>
            <th>{{ lang?.outcome }}</th>
            <th>{{ lang?.notes }}</th>
            <th>{{ lang?.cost }}</th>
            <th>{{ lang?.action }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let record of records let i = index" id="{{record.employee_id}}">
            <td>{{i+1}}</td>
            <td><a [routerLink]="['/'+employee+'/'+record.employee_id]" class="blue_action">{{ record?.employee_name
                }}</a> </td>
            <td>{{ record?.outome }}</td>
            <td>
              <div [innerHTML]="record?.notes | safeHtml"></div>
            </td>
            <td>
              <div [innerHTML]="record?.cost | safeHtml"></div>
            </td>
            <td>
              <div class="btn-group dropup">
                <button type="button" class="btn btn-info dropdown-toggle circle_btn" data-toggle="dropdown"
                  aria-expanded="false"><i class="fa fa-tasks"></i></button>
                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="edit_action"
                      (click)="edit(record?.employee_id)"><i class="fa fa-edit"></i>{{ lang?.modify }}</a>
                  </li>
                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="delete_action"
                    (click)="delete(record?.intervention_id)"><i class="fa fa-trash"></i> {{ lang?.erase }}</a></li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>

      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-success">{{ lang?.save }}</button>
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ lang?.close }}</button>
  </div>
</form>